module.exports = __webpack_public_path__ + "img/0913_cover.eacda226.jpg";